import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "@/components/site/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

const inputCls = "w-full bg-[#0B0C10] border border-[#F5A524]/30 focus:border-[#F5A524] outline-none px-4 py-3 font-mono text-sm text-white transition-colors";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#0B0C10] grid-lines grid place-items-center px-5 relative grain">
      <form onSubmit={submit} data-testid="admin-login-form" className="relative w-full max-w-md clip-corner bg-[#F5A524]/40 p-px">
        <div className="clip-corner bg-[#12131A] p-8 sm:p-10">
          <Link to="/" data-testid="admin-login-home-link"><Logo /></Link>
          <p className="mt-10 font-mono text-xs tracking-[0.35em] text-[#F5A524]">// SYS_OVERRIDE</p>
          <h1 className="mt-2 font-display font-black uppercase text-5xl">Admin Access</h1>
          <div className="mt-8 space-y-4">
            <input data-testid="admin-email-input" type="email" required placeholder="EMAIL" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
            <input data-testid="admin-password-input" type="password" required placeholder="PASSWORD" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
          </div>
          {error && <p data-testid="admin-login-error" className="mt-4 font-mono text-xs text-[#FF2A55]">! {error}</p>}
          <button data-testid="admin-login-submit" disabled={busy}
            className="mt-8 w-full clip-tab bg-[#F5A524] text-black font-mono font-bold tracking-[0.25em] py-4 hover:bg-white disabled:opacity-60 transition-colors">
            {busy ? "AUTHENTICATING..." : "JACK IN"}
          </button>
        </div>
      </form>
    </main>
  );
}
